import {CHAT_MDOEL} from '@/constants/common-const'
const DEFAULT_CHAT_KEY = "chat_model"
const DEFAULT_CHAT_MODEL = CHAT_MDOEL.PLAT_FORM.value

/**
 * 获取对话模式
 * @returns 
 */
export function getChatModel(){
    let local_chat_model = localStorage.getItem(DEFAULT_CHAT_KEY)
    if(local_chat_model){
        return local_chat_model
    }
    return DEFAULT_CHAT_MODEL
}

/**
 * 设置对话模式
 * @param {*} chatModel 
 */
export function setChatModel(chatModel){
    localStorage.setItem(DEFAULT_CHAT_KEY,chatModel)
}

